// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__nEH_S","positive":"styles_positive__nooN0","negative":"styles_negative__6xPri","footnote":"styles_footnote__hwscN"};